<template>
  <div class="push-config-page">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营部</el-breadcrumb-item>
      <el-breadcrumb-item>推送管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主内容区 -->
    <el-card class="main-card" shadow="hover">
      <!-- 工具栏 -->
      <div class="toolbar">
        <!-- 第一行：筛选与操作 -->
        <div class="toolbar-row">
        <el-input
          v-model="queryInfo.keyword"
          placeholder="项目名称/店铺名称"
          clearable
          size="small"
          style="width: 220px"
          @clear="handleSearch"
        ></el-input>
        <el-select
          v-model="queryInfo.groupBound"
          placeholder="企微群"
          size="small"
          style="width: 130px"
          @change="handleSearch"
        >
          <el-option label="企微群：全部" value="all"></el-option>
          <el-option label="已绑定群" value="bound"></el-option>
          <el-option label="未绑定群" value="unbound"></el-option>
        </el-select>
        <el-select
          v-if="!myRights.isSelfOnly"
          v-model="queryInfo.operatorId"
          placeholder="运营师"
          size="small"
          clearable
          filterable
          style="width: 150px"
          @change="handleSearch"
        >
          <el-option
            v-for="item in operatorOptions"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          ></el-option>
        </el-select>
        <el-select
          v-if="!myRights.isSelfOnly"
          v-model="queryInfo.currentOperatorId"
          placeholder="现阶段负责人"
          size="small"
          clearable
          filterable
          style="width: 150px"
          @change="handleSearch"
        >
          <el-option
            v-for="item in operatorOptions"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          ></el-option>
        </el-select>
        <el-select
          v-model="queryInfo.brand"
          placeholder="品牌"
          size="small"
          clearable
          style="width: 120px"
          @change="handleSearch"
        >
          <el-option v-for="item in brandList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-select
          v-model="queryInfo.dailyReport"
          placeholder="日报推送"
          size="small"
          style="width: 150px"
          @change="handleSearch"
        >
          <el-option label="日报推送：全部" value="all"></el-option>
          <el-option label="已开启" value="on"></el-option>
          <el-option label="已关闭" value="off"></el-option>
        </el-select>
        <el-select
          v-model="queryInfo.negativeComment"
          placeholder="差评推送"
          size="small"
          style="width: 150px"
          @change="handleSearch"
        >
          <el-option label="差评推送：全部" value="all"></el-option>
          <el-option label="已开启" value="on"></el-option>
          <el-option label="已关闭" value="off"></el-option>
        </el-select>
        <el-select
          v-model="queryInfo.neutralComment"
          placeholder="中评推送"
          size="small"
          style="width: 150px"
          @change="handleSearch"
        >
          <el-option label="中评推送：全部" value="all"></el-option>
          <el-option label="已开启" value="on"></el-option>
          <el-option label="已关闭" value="off"></el-option>
        </el-select>
        <el-select
          v-model="queryInfo.patrolEx"
          placeholder="异常推送"
          size="small"
          style="width: 150px"
          @change="handleSearch"
        >
          <el-option label="异常推送：全部" value="all"></el-option>
          <el-option label="已开启" value="on"></el-option>
          <el-option label="已关闭" value="off"></el-option>
        </el-select>
        <el-select
          v-model="queryInfo.commentAutoReply"
          placeholder="评价自动回复"
          size="small"
          style="width: 180px"
          @change="handleSearch"
        >
          <el-option label="评价自动回复：全部" value="all"></el-option>
          <el-option label="已开启" value="on"></el-option>
          <el-option label="已关闭" value="off"></el-option>
        </el-select>
        <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="handleReset">重置</el-button>
        <el-button v-if="myRights.canBatch" type="success" size="small" icon="el-icon-set-up" @click="handleInit">初始化配置</el-button>
        </div>

        <!-- 第二行：批量设置 -->
        <div class="toolbar-row" v-if="myRights.canBatch">
        <!-- 批量操作 -->
        <span class="batch-label">批量设置：</span>
        <el-dropdown size="small" trigger="click" type="primary" @command="handleBatchCommand" :disabled="batchLoading">
          <el-button size="small" type="primary" :disabled="batchLoading">
            日报推送<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ switchType: 'dailyReport', enabled: true }">全部开启</el-dropdown-item>
            <el-dropdown-item :command="{ switchType: 'dailyReport', enabled: false }">全部关闭</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown size="small" trigger="click" type="primary" @command="handleBatchCommand" :disabled="batchLoading">
          <el-button size="small" type="primary" :disabled="batchLoading">
            差评推送<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ switchType: 'negativeComment', enabled: true }">全部开启</el-dropdown-item>
            <el-dropdown-item :command="{ switchType: 'negativeComment', enabled: false }">全部关闭</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown size="small" trigger="click" type="primary" @command="handleBatchCommand" :disabled="batchLoading">
          <el-button size="small" type="primary" :disabled="batchLoading">
            中评推送<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ switchType: 'neutralComment', enabled: true }">全部开启</el-dropdown-item>
            <el-dropdown-item :command="{ switchType: 'neutralComment', enabled: false }">全部关闭</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown size="small" trigger="click" type="primary" @command="handleBatchCommand" :disabled="batchLoading">
          <el-button size="small" type="primary" :disabled="batchLoading">
            异常推送<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ switchType: 'patrolEx', enabled: true }">全部开启</el-dropdown-item>
            <el-dropdown-item :command="{ switchType: 'patrolEx', enabled: false }">全部关闭</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown size="small" trigger="click" type="primary" @command="handleBatchCommand" :disabled="batchLoading">
          <el-button size="small" type="primary" :disabled="batchLoading">
            评价自动回复<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ switchType: 'commentAutoReply', enabled: true }">全部开启</el-dropdown-item>
            <el-dropdown-item :command="{ switchType: 'commentAutoReply', enabled: false }">全部关闭</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        </div>
      </div>

      <!-- 提示信息 -->
      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 12px"
      >
        <template slot="title">
          仅展示「运营中」的项目。日报/差评/中评/异常推送需先在「项目群管理」绑定企微群。
          未绑定群的项目可使用上方筛选器选出后前往「项目群管理」补绑。异常推送由负责人开启后，
          巡店助手检测到的事件类新增异常（营业异常/风险管控等）将推送到该项目企微群。
        </template>
      </el-alert>

      <!-- 列表表格 -->
      <el-table
        :data="list"
        border
        size="small"
        v-loading="loading"
        :height="tableHeight"
        class="data-table"
      >
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="storeName" label="当前店铺" min-width="140" show-overflow-tooltip></el-table-column>
        <!-- 运营师 -->
        <el-table-column label="运营师" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.yunyingNames.length ? scope.row.yunyingNames.join('、') : '未分配' }}
          </template>
        </el-table-column>

        <!-- 企微群绑定状态 -->
        <el-table-column label="企微群" min-width="180">
          <template slot-scope="scope">
            <template v-if="scope.row.groupBound">
              <el-tag type="success" size="mini" style="margin-right: 6px">已绑定</el-tag>
              <span>{{ scope.row.groupName }}</span>
            </template>
            <template v-else>
              <el-tag type="danger" size="mini">未绑定</el-tag>
            </template>
          </template>
        </el-table-column>

        <!-- 日报推送开关（第一阶段可用） -->
        <el-table-column label="日报推送" width="110" align="center">
          <template slot-scope="scope">
            <el-tooltip
              :disabled="scope.row.groupBound"
              content="请先绑定企微群"
              placement="top"
            >
              <span>
                <el-switch
                  v-model="scope.row.dailyReport.enabled"
                  :disabled="!scope.row.groupBound || switching"
                  @change="handleSwitchChange(scope.row, 'dailyReport')"
                  active-color="#13ce66"
                ></el-switch>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 差评推送开关 -->
        <el-table-column label="差评推送" width="110" align="center">
          <template slot-scope="scope">
            <el-tooltip
              :disabled="scope.row.groupBound"
              content="请先绑定企微群"
              placement="top"
            >
              <span>
                <el-switch
                  v-model="scope.row.negativeComment.enabled"
                  :disabled="!scope.row.groupBound || switching"
                  @change="handleSwitchChange(scope.row, 'negativeComment')"
                  active-color="#13ce66"
                ></el-switch>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 中评推送开关 -->
        <el-table-column label="中评推送" width="110" align="center">
          <template slot-scope="scope">
            <el-tooltip
              :disabled="scope.row.groupBound"
              content="请先绑定企微群"
              placement="top"
            >
              <span>
                <el-switch
                  v-model="scope.row.neutralComment.enabled"
                  :disabled="!scope.row.groupBound || switching"
                  @change="handleSwitchChange(scope.row, 'neutralComment')"
                  active-color="#13ce66"
                ></el-switch>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 巡店异常推送开关 -->
        <el-table-column label="异常推送" width="110" align="center">
          <template slot-scope="scope">
            <el-tooltip
              :disabled="scope.row.groupBound"
              content="请先绑定企微群"
              placement="top"
            >
              <span>
                <el-switch
                  v-model="scope.row.patrolEx.enabled"
                  :disabled="!scope.row.groupBound || switching"
                  @change="handleSwitchChange(scope.row, 'patrolEx')"
                  active-color="#13ce66"
                ></el-switch>
              </span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- 评价自动回复开关 -->
        <el-table-column label="评价自动回复" width="120" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.commentAutoReply.enabled"
              :disabled="switching"
              @change="handleSwitchChange(scope.row, 'commentAutoReply')"
              active-color="#13ce66"
            ></el-switch>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagenum"
        :page-sizes="[20, 50, 100]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { brandList } from '@/utility/staticData'

export default {
  name: 'PushConfig',
  data () {
    return {
      // 筛选条件
      queryInfo: {
        keyword: '',
        groupBound: 'all',
        operatorId: '',
        currentOperatorId: '',
        brand: '',
        dailyReport: 'all',
        negativeComment: 'all',
        neutralComment: 'all',
        patrolEx: 'all',
        commentAutoReply: 'all'
      },

      // 品牌列表
      brandList,

      // 列表数据
      list: [],
      total: 0,
      pagenum: 1,
      pagesize: 20,
      loading: false,

      // 运营师下拉列表
      yunyingList: [],

      // 开关切换中
      switching: false,

      // 批量操作进行中
      batchLoading: false,

      // 推送类型显示名称映射
      switchLabels: {
        dailyReport: '日报推送',
        negativeComment: '差评推送',
        neutralComment: '中评推送',
        patrolEx: '异常推送',
        commentAutoReply: '评价自动回复'
      },

      // 当前用户权限标记（由列表接口返回，控制按钮显隐）
      myRights: { isSelfOnly: false, canBatch: false }
    }
  },
  computed: {
    tableHeight () {
      return window.innerHeight - 300
    },
    // 负责人下拉选项（与 Dianpu.vue / DailyReport.vue 保持一致的岗位过滤）
    operatorOptions () {
      return this.yunyingList.filter(e => /运营师|运营主管|建店专员/.test(e.job))
    }
  },
  created () {
    this.getYunyingList()
    this.getList()
  },
  methods: {
    // 获取运营师下拉列表
    async getYunyingList () {
      try {
        const { data: res } = await this.$http.get('yunying/employees/list')
        if (res.meta.status !== 200) {
          console.error('获取运营师列表失败:', res.meta.msg)
          return
        }
        this.yunyingList = res.data || []
      } catch (e) {
        console.error('获取运营师列表失败:', e)
      }
    },

    // 获取列表数据
    async getList () {
      this.loading = true
      try {
        const params = {
          pagenum: this.pagenum,
          pagesize: this.pagesize
        }
        if (this.queryInfo.keyword) {
          params.keyword = this.queryInfo.keyword
        }
        if (this.queryInfo.groupBound && this.queryInfo.groupBound !== 'all') {
          params.groupBound = this.queryInfo.groupBound
        }
        if (this.queryInfo.operatorId) {
          params.operatorId = this.queryInfo.operatorId
        }
        if (this.queryInfo.currentOperatorId) {
          params.currentOperatorId = this.queryInfo.currentOperatorId
        }
        if (this.queryInfo.brand) {
          params.brand = this.queryInfo.brand
        }
        if (this.queryInfo.dailyReport && this.queryInfo.dailyReport !== 'all') {
          params.dailyReport = this.queryInfo.dailyReport
        }
        if (this.queryInfo.negativeComment && this.queryInfo.negativeComment !== 'all') {
          params.negativeComment = this.queryInfo.negativeComment
        }
        if (this.queryInfo.neutralComment && this.queryInfo.neutralComment !== 'all') {
          params.neutralComment = this.queryInfo.neutralComment
        }
        if (this.queryInfo.patrolEx && this.queryInfo.patrolEx !== 'all') {
          params.patrolEx = this.queryInfo.patrolEx
        }
        if (this.queryInfo.commentAutoReply && this.queryInfo.commentAutoReply !== 'all') {
          params.commentAutoReply = this.queryInfo.commentAutoReply
        }

        const { data: res } = await this.$http.get('yunying/pushConfig/list', { params })
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }
        this.list = res.data.list || []
        this.total = res.data.total || 0
        this.myRights = res.data.myRights || { isSelfOnly: false, canBatch: false }
      } catch (error) {
        this.$message.error('获取推送配置列表失败')
        console.error('获取推送配置列表失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 查询
    handleSearch () {
      this.pagenum = 1
      this.getList()
    },

    // 重置
    handleReset () {
      this.queryInfo = {
        keyword: '',
        groupBound: 'all',
        operatorId: '',
        currentOperatorId: '',
        brand: '',
        dailyReport: 'all',
        negativeComment: 'all',
        neutralComment: 'all',
        patrolEx: 'all',
        commentAutoReply: 'all'
      }
      this.pagenum = 1
      this.getList()
    },

    // 分页大小变更
    handleSizeChange (newSize) {
      this.pagesize = newSize
      this.pagenum = 1
      this.getList()
    },

    // 页码变更
    handleCurrentChange (newPage) {
      this.pagenum = newPage
      this.getList()
    },

    // 开关切换
    async handleSwitchChange (row, switchType) {
      const newVal = row[switchType].enabled
      const label = this.switchLabels[switchType] || switchType
      this.switching = true
      try {
        const { data: res } = await this.$http.put('yunying/pushConfig/update', {
          projectId: row.projectId,
          switchType,
          enabled: newVal
        })
        if (res.meta.status !== 200) {
          // 回滚开关状态
          row[switchType].enabled = !newVal
          this.$message.error(res.meta.msg)
          return
        }
        this.$message.success(newVal ? `已开启${label}` : `已关闭${label}`)
      } catch (error) {
        // 回滚开关状态
        row[switchType].enabled = !newVal
        this.$message.error('更新失败')
        console.error('更新推送开关失败:', error)
      } finally {
        this.switching = false
      }
    },

    // 批量初始化配置
    async handleInit () {
      try {
        await this.$confirm('将为所有「运营中」的项目创建缺失的推送配置（不会覆盖已有配置），是否继续？', '初始化推送配置', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        })
      } catch (e) {
        return
      }

      this.loading = true
      try {
        const { data: res } = await this.$http.post('yunying/pushConfig/init')
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }
        const s = res.data
        this.$message.success(`初始化完成：共${s.total}个运营中项目，新增${s.created}份配置`)
        this.getList()
      } catch (error) {
        this.$message.error('初始化失败')
        console.error('初始化推送配置失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 批量设置推送开关（作用于所有运营中项目）
    async handleBatchCommand ({ switchType, enabled }) {
      const label = this.switchLabels[switchType] || switchType
      const action = enabled ? '开启' : '关闭'
      // 日报/差评/中评/异常推送开启需绑定群，未绑定项目将自动跳过
      const needGroup = (switchType === 'dailyReport' || switchType === 'negativeComment' || switchType === 'neutralComment' || switchType === 'patrolEx') && enabled
      let tip = `确认将所有「运营中」项目的「${label}」全部${action}？`
      if (needGroup) {
        tip += '\n（未绑定企微群的项目将自动跳过）'
      }
      try {
        await this.$confirm(tip, '批量操作确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.batchLoading = true
      try {
        const { data: res } = await this.$http.put('yunying/pushConfig/batchUpdate', {
          switchType,
          enabled
        })
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          // bulkWrite ordered:true 部分失败时可能已部分写入，刷新以对齐 DB
          this.getList()
          return
        }
        const s = res.data
        let msg = `${label}已全部${action}：成功${s.updated}条`
        if (s.skipped > 0) {
          msg += `，跳过${s.skipped}条（未绑定群）`
        }
        this.$message.success(msg)
        this.getList()
      } catch (error) {
        this.$message.error('批量操作失败')
        console.error('批量更新推送开关失败:', error)
      } finally {
        this.batchLoading = false
      }
    }
  }
}
</script>

<style scoped>
.push-config-page {
  padding: 0 4px;
}

.breadcrumb {
  margin-bottom: 16px;
}

.main-card {
  border-radius: 8px;
  border: 1px solid #e8ecf1;
}

/* 工具栏 */
.toolbar {
  padding: 16px 0 12px;
}

/* 工具栏单行 */
.toolbar-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.toolbar-row + .toolbar-row {
  margin-top: 10px;
}

/* 批量操作标签 */
.batch-label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

/* 分页 */
.pagination {
  padding: 14px 0 0;
  text-align: right;
}
</style>
